/**
 * CRL-3241 login phone rules (new-design.html `CONFIG.phone` + `formatPhone`):
 * "+90" prefix, 10 national digits starting with 5, shown as "5XX XXX XX XX".
 */
export const PHONE_PATTERN = /^5\d{9}$/;

/** react-input-mask: 3-3-2-2 groups, first digit fixed to 5. */
export const PHONE_MASK = "baa aaa aa aa";
export const PHONE_MASK_CHARS = { b: "5", a: "[0-9]" };

/** "532 123 45 67" -> "5321234567" (what the API receives). */
export const phoneDigits = (value: string): string => value.replace(/\D/g, "");

export const isValidPhone = (value: string): boolean =>
  PHONE_PATTERN.test(phoneDigits(value));
